export default __webpack_public_path__ + "static/7_19-1c9d383e147011cfad609cbece17d183.png";